import React from "react";
import { useRootAppStore } from "@hooks";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default function ChatCloseButton() {
	const { chatViewStore } = useRootAppStore();

	const closeChatWindow = () => {
		chatViewStore.closeChat();
	};

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Mobile/ChatCloseButton.tsx"}
		>
			<button
				onClick={closeChatWindow}
				className="btn btn--tny btn--square--sml btn--primary--inverted btn--animate-grow btn--icon"
			>
				<i className="btn__icon u-icon u-icon--tny u-icon--close" />
			</button>
		</ErrorBoundaryWithPropagation>
	);
}
